module.exports = __webpack_public_path__ + "static/media/fa2013cabs-crop.4e68d9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/QED/fa2013cabs-crop.jpg
// module id = 175
// module chunks = 0